<template>
  <div class="pnav animation srcospcur" v-if="list.length>0">
    <div class="tit">{{$route.meta.name}}</div>
    <input type="hidden" value="/about/aboutus.htm" id="about_url" />
    <ul>
      <li v-for="item in list" :key="item.nodeId">
        <a
          href="javascript:;"
          title
          :class="activeId==item.nodeId?'cur':''"
          @click="handleClick(item)"
        >{{item.nodeName}}</a>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Array,
      default: function() {
        return [];
      }
    },
    id: [Number, String]
  },
  data() {
    return {
      list: this.$props.data,
      activeId: this.$props.id
    };
  },
  methods: {
    handleClick(item) {
      this.activeId = item.nodeId;
      this.$router.push({
        name: this.$route.name,
        params: { pId: this.$route.params.pId, cId: item.nodeId }
      });
    }
  }
};
</script>